<template>
  <div class="list-container" v-if="hasDocuments && !hideMeetingDocuments">
    <div class="icon">
      <i class="material-icons">file_download</i>
    </div>
    <div class="item-container">
      <div class="title">Meeting Documents</div>
      <a
        v-for="(doc, index) in meetingDocuments"
        :key="index"
        class="download-text"
        :href="doc.url"
        target="_blank"
      >
        {{ doc.name }} ({{ formattedFileSize(doc) }})
      </a>
    </div>
  </div>
  <div class="expired-container" v-else>
    <span
      class="mdl-card__supporting-text"
      v-if="this.isExpired && this.isClosed"
    >
      Meeting has closed, download is no longer available.
    </span>
  </div>
</template>

<script>
import filesize from 'filesize';
import _ from 'lodash';

export default {
  name: 'DownloadListItem',
  props: {
    meetingDocuments: {
      type: Array,
      default() {
        return [];
      }
    },
    isClosed: {
      type: Boolean,
      default: false
    },
    isExpired: {
      type: Boolean,
      default: false
    },
    displayOptions: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    hideMeetingDocuments() {
      // Show meeting documents by default
      return _.get(this.displayOptions, 'home.hide_meeting_documents', false);
    },
    hasDocuments() {
      return this.meetingDocuments.length > 0;
    }
  },
  methods: {
    isNumber(obj) {
      return !isNaN(obj);
    },
    formattedFileSize(document) {
      if (this.isNumber(document.size)) {
        return filesize(document.size);
      }
    }
  }
};
</script>

<style scoped>
.list-container {
  display: flex;
}
.item-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-wrap: wrap;
}
.item-container > .title {
  font-size: 14px;
  font-weight: 600;
}
.subtitle {
  font-size: 14px;
  opacity: 0.65;
}
.icon {
  min-width: 35px;
  padding-top: 5px;
  color: #3f51b5;
  opacity: 0.8;
}
.expired-container {
  margin-top: 20px;
  width: 80%;
}
.mdl-card__supporting-text {
  padding: 0px;
  width: 100%;
}
.download-text {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/DownloadListItem.vue